/* =========================================================================
   IDEAMAX USA — "Complete with blanks" cross-sell picker.
   Single variant  -> add straight to cart.
   Multi variant   -> open a modal: pick colour + size, choose quantity,
                      preview the matching variant image, then add to cart.
   Mirrors Minimog's own add flow so the cart drawer opens & refreshes.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__ixQuickAdd) return;
  window.__ixQuickAdd = true;

  /* ---------- cart ---------- */
  function addToCart(variantId, quantity, btn, onDone) {
    if (!variantId) return;
    var sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
    } catch (e) {}

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', quantity || 1);
    fd.append('sections', sections);
    fd.append('sections_url', window.location.pathname);

    if (btn) btn.classList.add('is-loading');
    var url = (window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_add_url) || '/cart/add';

    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) { if (onDone) onDone(false); return; }
        try {
          var drawer = document.querySelector('m-cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        } catch (e) {}
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: res, productVariantId: String(variantId) });
        } else {
          document.querySelectorAll('.cart-count, .m-cart-count').forEach(function (el) {
            el.textContent = (parseInt(el.textContent, 10) || 0) + (quantity || 1);
          });
        }
        if (onDone) onDone(true);
      })
      .catch(function () { if (onDone) onDone(false); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- helpers ---------- */
  function isColorOption(name) { return /colou?r/i.test(name || ''); }

  // First variant whose options match the given partial selection (index->value).
  function firstMatch(data, sel) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], ok = true;
      for (var k in sel) {
        if (sel[k] != null && v.options[k] !== sel[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function exactVariant(data, sel) {
    if (data.options.some(function (o, i) { return sel[i] == null; })) return null;
    return firstMatch(data, sel);
  }

  // Does an available variant exist if option `idx` were set to `value`,
  // keeping every other currently-selected option?
  function valueAvailable(data, sel, idx, value) {
    var probe = sel.slice();
    probe[idx] = value;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (!v.available) continue;
      var ok = true;
      for (var k = 0; k < probe.length; k++) {
        if (probe[k] != null && v.options[k] !== probe[k]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  // Image for the current (possibly partial) selection.
  function previewImage(data, sel) {
    var ex = exactVariant(data, sel);
    if (ex && ex.image) return ex.image;
    var m = firstMatch(data, sel);
    if (m && m.image) return m.image;
    for (var i = 0; i < data.variants.length; i++) { if (data.variants[i].image) return data.variants[i].image; }
    return data.featured;
  }

  // First variant image for a specific value of one option (for colour swatches).
  function valueImage(data, idx, value) {
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].options[idx] === value && data.variants[i].image) return data.variants[i].image;
    }
    return data.featured;
  }

  /* ---------- modal ---------- */
  var modal, state = null; // state = { data, sel: [] }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'ix-modal';
    // Critical layout as inline styles so a missing/overridden stylesheet can't break
    // the overlay (guarantees the dimmed backdrop + centering + top stacking).
    modal.style.cssText = 'display:none;position:fixed;inset:0;z-index:2147483647;align-items:center;justify-content:center;padding:16px;';
    modal.innerHTML =
      '<div class="ix-modal-backdrop" data-close style="position:absolute;inset:0;background:rgba(20,15,12,.62);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);"></div>' +
      '<div class="ix-modal-panel" role="dialog" aria-modal="true" style="position:relative;z-index:1;">' +
        '<button type="button" class="ix-modal-close" data-close aria-label="Close">&times;</button>' +
        '<div class="ix-modal-media"><img alt=""></div>' +
        '<div class="ix-modal-body">' +
          '<a class="ix-modal-title" href="#"></a>' +
          '<div class="ix-modal-price"></div>' +
          '<div class="ix-modal-opts"></div>' +
          '<div class="ix-modal-qty">' +
            '<span class="ix-modal-qty-label">Qty</span>' +
            '<span class="ix-qty-box">' +
              '<button type="button" data-step="-1" aria-label="Decrease">&minus;</button>' +
              '<input type="number" min="1" value="1" inputmode="numeric">' +
              '<button type="button" data-step="1" aria-label="Increase">+</button>' +
            '</span>' +
          '</div>' +
          '<button type="button" class="ix-modal-add"></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { closeModal(); return; }
      var step = e.target.closest('[data-step]');
      if (step) { bumpQty(parseInt(step.getAttribute('data-step'), 10)); return; }
      var val = e.target.closest('[data-oi]');
      if (val && !val.classList.contains('is-unavailable')) {
        selectValue(parseInt(val.getAttribute('data-oi'), 10), val.getAttribute('data-value'));
        return;
      }
      var add = e.target.closest('.ix-modal-add');
      if (add && !add.disabled) doAdd();
    });
    modal.querySelector('input').addEventListener('change', function () {
      var n = parseInt(this.value, 10);
      this.value = (!n || n < 1) ? 1 : n;
    });
  }

  function openModal(data, presel) {
    if (!modal) buildModal();
    state = { data: data, sel: data.options.map(function () { return null; }) };
    // Pre-select any option that has only one value.
    data.options.forEach(function (o, i) { if (o.values.length === 1) state.sel[i] = o.values[0]; });
    // Optional preselection, e.g. from a hovered colour swatch on the card:
    // presel = { "Color": "Navy" }. Only applied when the value really exists.
    if (presel) {
      data.options.forEach(function (o, i) {
        var want = presel[o.name];
        if (want != null && o.values.indexOf(want) !== -1) state.sel[i] = want;
      });
    }
    modal.querySelector('.ix-modal-title').textContent = data.title;
    modal.querySelector('.ix-modal-title').href = data.url;
    modal.querySelector('input').value = 1;
    renderOptions();
    render();
    modal.style.display = 'flex';
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    if (modal) modal.style.display = 'none';
    document.documentElement.style.overflow = '';
    state = null;
  }

  function selectValue(idx, value) {
    if (state.sel[idx] === value) return;
    state.sel[idx] = value;
    render();
  }

  function bumpQty(delta) {
    var input = modal.querySelector('input');
    var n = (parseInt(input.value, 10) || 1) + delta;
    input.value = n < 1 ? 1 : n;
  }

  function renderOptions() {
    var data = state.data;
    var html = data.options.map(function (opt, idx) {
      var swatch = isColorOption(opt.name);
      var vals = opt.values.map(function (val) {
        var cls = 'data-oi="' + idx + '" data-value="' + String(val).replace(/"/g, '&quot;') + '"';
        if (swatch) {
          return '<button type="button" class="ix-swatch" ' + cls + ' title="' + String(val).replace(/"/g, '&quot;') + '">' +
                 '<img src="' + valueImage(data, idx, val) + '" alt=""></button>';
        }
        return '<button type="button" class="ix-pill" ' + cls + '>' + val + '</button>';
      }).join('');
      return '<div class="ix-opt" data-opt-idx="' + idx + '">' +
               '<div class="ix-opt-h">' + opt.name + ': <span></span></div>' +
               '<div class="ix-opt-vals">' + vals + '</div>' +
             '</div>';
    }).join('');
    modal.querySelector('.ix-modal-opts').innerHTML = html;
  }

  // Refresh selected states, availability, image, price and the add button.
  function render() {
    var data = state.data, sel = state.sel;
    // option buttons
    modal.querySelectorAll('.ix-opt').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-opt-idx'), 10);
      group.querySelector('.ix-opt-h span').textContent = sel[idx] || '';
      group.querySelectorAll('[data-oi]').forEach(function (btn) {
        var value = btn.getAttribute('data-value');
        btn.classList.toggle('is-selected', sel[idx] === value);
        btn.classList.toggle('is-unavailable', !valueAvailable(data, sel, idx, value));
      });
    });
    // image
    modal.querySelector('.ix-modal-media img').src = previewImage(data, sel);
    // price + add button
    var ex = exactVariant(data, sel);
    var priceEl = modal.querySelector('.ix-modal-price');
    var addBtn = modal.querySelector('.ix-modal-add');
    if (ex) {
      priceEl.textContent = ex.price;
      if (ex.available) { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
      else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
    } else {
      // show cheapest matching variant as a "from" price
      var min = null;
      data.variants.forEach(function (v) {
        var ok = true;
        for (var k = 0; k < sel.length; k++) { if (sel[k] != null && v.options[k] !== sel[k]) { ok = false; break; } }
        if (ok && (min === null || v.priceCents < min.priceCents)) min = v;
      });
      priceEl.textContent = min ? min.price : '';
      addBtn.disabled = true;
      addBtn.textContent = 'Select options';
    }
  }

  function doAdd() {
    var ex = exactVariant(state.data, state.sel);
    if (!ex || !ex.available) return;
    var qty = parseInt(modal.querySelector('input').value, 10) || 1;
    var addBtn = modal.querySelector('.ix-modal-add');
    addToCart(ex.id, qty, addBtn, function (ok) { if (ok) closeModal(); });
  }

  /* ---------- card triggers ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.ix-xsell-add');
    if (!add) return;
    e.preventDefault();
    e.stopPropagation();
    var card = add.closest('.ix-xsell-card');
    var count = parseInt(add.getAttribute('data-variant-count'), 10) || 1;
    var dataEl = card && card.querySelector('.ix-xsell-data');
    if (count > 1 && dataEl) {
      var presel = null;
      var preselRaw = card.getAttribute('data-ix-presel');
      if (preselRaw) { try { presel = JSON.parse(preselRaw); } catch (err) {} }
      try { openModal(JSON.parse(dataEl.textContent), presel); }
      catch (err) { addToCart(add.getAttribute('data-variant-id'), 1, add); }
    } else {
      addToCart(add.getAttribute('data-variant-id'), 1, add);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.style.display !== 'none') closeModal();
  });

  /* ---------- blanks card swatches ----------
     A colour swatch on an ixbl product card swaps the card image to that
     variant and records the colour (data-ix-presel) so the quick-add modal
     opens preselected. Swatches sit inside the card's product link, so taps
     on them must NOT navigate — only the main image / title do. No-op on
     pages without these cards. */
  function applySwatch(sw) {
    var card = sw.closest('.ixbl-bs-card');
    if (!card) return;
    var img = sw.getAttribute('data-img');
    var main = card.querySelector('.ixbl-bs-mainimg');
    if (img && main && main.src !== img) main.src = img;
    var opt = sw.closest('.ixbl-bs-swatches').getAttribute('data-opt');
    var val = sw.getAttribute('data-val');
    if (opt && val) {
      var presel = {};
      presel[opt] = val;
      card.setAttribute('data-ix-presel', JSON.stringify(presel));
    }
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.ixbl-bs-sw');
    if (sw) applySwatch(sw);
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.ixbl-bs-sw');
    if (!sw) return;
    // Tap = select colour only; never follow the wrapping product link.
    e.preventDefault();
    e.stopPropagation();
    applySwatch(sw);
  });

  // If a swap's image load was cut short by a navigation, the restored
  // back/forward-cache page shows a broken img — re-kick the loads.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.ixbl-bs-mainimg').forEach(function (im) {
      if (im.complete && im.naturalWidth === 0 && im.src) {
        var src = im.src;
        im.src = '';
        im.src = src;
      }
    });
  });
})();
